"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adspotWrapper = void 0;

var _core = require("@emotion/core");

/* eslint-disable import/prefer-default-export */
// Allow absolute positioning within container
var adspotWrapper = {
  name: "79elbk",
  styles: "position:relative;"
};
exports.adspotWrapper = adspotWrapper;